import log from 'salvo-lite/log'

class SearchPage {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._resultsText = elem.querySelector('.search__results-text span')
        this._checkResults = true
        this._numberResults = 0
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        this._observer()
    }
    _observer () {
        const config = { attributes: true, childList: true, subtree: true }
        const callback = (mutationsList, observer) => {
            for (let mutation of mutationsList) {
                if (mutation.target.classList.contains('boost-pfs-filter-products')) {
                    this._doComponents()
                }
                if (this._checkResults) {
                    this._findNumberResults()
                }
            }
        }
        let observer = new MutationObserver(callback)
        observer.observe(this._elem, config)
    }
    _doComponents () {
        let products = this._elem.querySelectorAll('.product-item')
        for (let product of products) {
            this._theme.registerComponents(product)
        }
    }
    _findNumberResults () {
        const resultLis = document.querySelectorAll('.boost-pfs-search-result-panel-item')
        if (resultLis.length > 0) {
            let number = 0
            resultLis.forEach(li => {
                number += parseInt(li.textContent.split('(')[1].split(')')[0])
            })
            this._numberResults = number
            this._checkResults = false
            this._resultsText.textContent = number
        }
    }
}

export default SearchPage



// WEBPACK FOOTER //
// ./src/resources/scripts/components/SearchPage.js